import React, { Component } from "react"
import { Card, CardBody, Col, Label, Input, FormGroup, CardColumns, CardTitle } from "reactstrap"
import { ToastContainer } from "react-toastify";
import {
    createNotificationHelpers,
    updateStoreShopifyPlus,
    MESSAGES
} from "../utils";

export default class ShopifyPlus extends Component {
    constructor(props) {
        super(props)
        this.state = {
            is_shopify_plus: props.is_shopify_plus || false,
            store_domain: props.store_domain || ''
        }

        // Initialize notification helpers
        const notifications = createNotificationHelpers();
        this.notify_info = notifications.notify_info;
        this.notify_error = notifications.notify_error;
        this.notify_success = notifications.notify_success;
    }

    // Update state when props change
    componentDidUpdate(prevProps) {
        if (prevProps.is_shopify_plus !== this.props.is_shopify_plus) {
            this.setState({ is_shopify_plus: this.props.is_shopify_plus });
        }
    }

    /**
     * Handles Shopify Plus checkbox change
     */
    handleChangeCheckbox = async () => {
        const answer = window.confirm("Are you sure you want to change?");
        if (!answer) {
            return;
        }

        const storeData = {
            store_domain: this.props.store_domain,
            is_shopify_plus: !this.state.is_shopify_plus
        };

        const success = await updateStoreShopifyPlus(
            storeData,
            this.notify_success,
            this.notify_error
        );

        if (success) {
            this.setState({ is_shopify_plus: !this.state.is_shopify_plus });
        }
    }
    render() {
        return (
            <React.Fragment>
                <Col xl={3}>
                    <Card>
                        <CardBody>
                            <CardTitle className="text-center mb-4" ><h5>Switching to Shopify Plus</h5></CardTitle>
                            <CardColumns>
                                <FormGroup className="form-check form-switch flex-column">
                                    <Label
                                        htmlFor="formSwitchChecked"
                                        className="col-form-label"
                                        style={{ textAlign: "center", fontWeight: "lighter", fontSize: "14px", marginBottom: "10px" }}

                                    >Is Shopify Plus ? </Label>
                                    <Input
                                        type="checkbox"
                                        name="is_shopify_plus"
                                        className="form-control form-switch"
                                        id="formSwitchChecked"
                                        onChange={this.handleChangeCheckbox}
                                        checked={this.state.is_shopify_plus}
                                        style={{ marginLeft: "60%", marginTop: "10px", marginBottom: "10px" }}

                                    />
                                </FormGroup>
                            </CardColumns>
                        </CardBody>
                    </Card>
                </Col>
            </React.Fragment >
        )
    }
}